module.exports = __webpack_public_path__ + "img/icon-context-mute-mentions.266796b.svg";